import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Paper, Typography, Chip, Tabs, Tab, Snackbar, Alert } from "@mui/material";
import {
  Description as RequestIcon,
  CheckCircleOutline as ApprovalIcon,
  GroupOutlined as AllocationIcon,
  AccountBalanceWalletOutlined as BalanceIcon,
} from "@mui/icons-material";
import HeaderBannerPage from "../../components/HeaderBannerPage";
import LeaveRequestTab from "./application/LeaveRequestTab";
import LeaveApprovalTab from "./application/LeaveApprovalTab";
import LeaveAllocationTab from "./application/LeaveAllocationTab";
import LeaveBalanceTab from "./application/LeaveBalanceTab";
import { NAVY, cardSx } from "../../components/leave/LeaveCommon";
import { getAllEmployees } from "../../actions/EmployeeRegisterAction";
import { fetchLeaveTypes } from "../../actions/Leave/LeaveTypeAction";
import { fetchLeaveRequests } from "../../actions/Leave/LeaveRequestAction";

const LeaveApplication = () => {
  const [tab, setTab] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const notify = (message, severity = "success") => setSnackbar({ open: true, message, severity });

  const dispatch = useDispatch();
  const { data: liveRequests = [] } = useSelector((s) => s.leaveRequests) || {};

  // employees + leave types for names, and the request lists for the Approval tab
  useEffect(() => {
    dispatch(getAllEmployees());
    dispatch(fetchLeaveTypes());
    dispatch(fetchLeaveRequests());
  }, [dispatch]);

  const pendingCount = liveRequests.filter((r) => r.status === "Pending").length;




  return (
    <Box sx={{ width: "100%", minHeight: "100vh" }}>
      <HeaderBannerPage />
      <Box sx={{ maxWidth: 1400, mx: "auto", mt: 4, px: 2, pb: 4 }}>
        {/* Banner */}
        <Paper
          elevation={0}
          sx={{
            p: 3, mb: 3, borderRadius: "12px",
            background: "linear-gradient(135deg, #1e0153 0%, #154c79 100%)",
            color: "#fff", boxShadow: "0px 4px 12px rgba(30, 1, 83, 0.15)",
          }}
        >
          <Chip
            label="LEAVE MANAGEMENT" size="small"
            sx={{ fontWeight: "bold", mb: 1, fontSize: "11px", letterSpacing: "0.5px", backgroundColor: "rgba(255,255,255,0.18)", color: "#fff" }}
          />
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5, fontFamily: "'Poppins', sans-serif" }}>
            Leave Application &amp; Balance
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.85, fontSize: "13px" }}>
            Manage leave requests, approvals, allocations and balances
          </Typography>
        </Paper>

        {/* Tabs */}
        <Paper elevation={0} sx={{ ...cardSx, mb: 2 }}>
          <Tabs
            value={tab}
            onChange={(e, v) => setTab(v)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-indicator": { backgroundColor: NAVY },
              "& .MuiTab-root": { textTransform: "none", fontWeight: 600, minHeight: 48 },
              "& .MuiTab-root.Mui-selected": { color: NAVY },
            }}
          >
            <Tab icon={<RequestIcon fontSize="small" />} iconPosition="start" label="Leave Request" />
            <Tab
              icon={<ApprovalIcon fontSize="small" />} iconPosition="start"
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  Leave Approval
                  {pendingCount > 0 && (
                    <Chip label={pendingCount} size="small" sx={{ height: 18, fontSize: 11, fontWeight: 700, backgroundColor: "#fef3c7", color: "#b45309" }} />
                  )}
                </Box>
              }
            />
            <Tab icon={<AllocationIcon fontSize="small" />} iconPosition="start" label="Leave Allocation" />
            <Tab icon={<BalanceIcon fontSize="small" />} iconPosition="start" label="Leave Balance" />
          </Tabs>
        </Paper>

        {tab === 0 && (
          <LeaveRequestTab onSubmitted={() => setTab(1)} />
        )}
        {tab === 1 && (
          <LeaveApprovalTab notify={notify} />
        )}
        {tab === 2 && <LeaveAllocationTab />}
        {tab === 3 && <LeaveBalanceTab />}
      </Box>

      <Snackbar
        open={snackbar.open} autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ borderRadius: "8px", fontWeight: 500 }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LeaveApplication;